import SentimentCard from '../../components/SentimentCard';
import useScan from '../../hooks/useScan';

export default function BrandSentimentCard() {
  const { data } = useScan();

  return (
    <SentimentCard
      title="Brand sentiment"
      data={data?.sentiment?.own}
      // https://www.figma.com/design/zH43jZJuvZyPaqrod8lG5u?node-id=2-5#1353634593
      tooltip="Percentage of positive versus negative keywords in your query results related to your brand."
    />
  );
}
